<template>
  <div class="mt-4 flex flex-col p-2 sm:p-8">
    <vx-card title="Orden confirmada" class="mb-2">
      <div class="text-xl"><b>Gracias {{ data.userName }} por comprar en Anfora</b></div>
      <div class="w-full my-8">
        Te hemos enviado un correo electrónico con información sobre tu pedido, por favor espera instrucciones por ese medio.
      </div>
      <div class="flex w-full text-2xl">
        <b>Número de orden: {{ data.id }}</b>
      </div>
    </vx-card>
    <vx-card title="Datos de la orden" class="mb-2">
      <div class="flex w-full">
        <div class="flex w-1/4">
          Fecha:
        </div>
        <div class="flex w-3/4">
          {{ orderDate }}
        </div>
      </div>
      <div class="flex w-full">
        <div class="flex w-1/4">
          Estado:
        </div>
        <div class="flex w-3/4">
          {{ data.status }}
        </div>
      </div>
      <div class="flex w-full">
        <div class="flex w-1/4">
          Correo electrónico:
        </div>
        <div class="flex w-3/4">
          {{ data.user }}
        </div>
      </div>
      <div class="flex w-full">
        <div class="flex w-1/4">
          Número de teléfono:
        </div>
        <div class="flex w-3/4">
          {{ data.phone }}
        </div>
      </div>
      <div class="flex w-full" v-if="data.deliveryType == 'delivery'">
        <div class="flex w-1/4">
          Dirección de entrega:
        </div>
        <div class="flex w-3/4">
          {{ data.address.address }}<br/>
          {{ data.address.cityName.trim() }}, {{ data.address.stateName }}
        </div>
      </div>
      <div class="flex w-full">
        <div class="flex w-1/4">
          <span v-if="data.deliveryType == 'delivery'">Tienda que envía la orden:</span>
          <span v-else>Tienda donde se recogerá la orden:</span>
        </div>
        <div class="flex w-3/4">
          {{ data.store.name }}<br/>
          {{ data.store.address }}
        </div>
      </div>
      <div class="flex w-full" v-if="data.orderNumber">
        <div class="flex w-1/4">
          Número de pedido:
        </div>
        <div class="flex w-3/4">
          {{ data.orderNumber }}
        </div>
      </div>
      <div class="flex w-full" v-if="data.address.deliveryInstructions">
        <div class="flex w-1/4">
          Instrucciones para despacho:
        </div>
        <div class="flex w-3/4">
          {{ data.address.deliveryInstructions }}
        </div>
      </div>
      <div class="flex w-full mt-4" v-if="data.discount">
        <div class="flex w-1/4">
          Subtotal:
        </div>
        <div class="flex w-3/4">
          {{ (data.orderTotal + data.discount).toFixed(2) }}
        </div>
      </div>
      <div class="flex w-full" v-if="data.couponCode">
        <div class="flex w-1/4">
          Cupón de descuento:
        </div>
        <div class="flex w-3/4 text-success">
          <b>{{ data.couponCode }}: {{ data.couponName }}</b>
        </div>
      </div>
      <div class="flex w-full" v-if="data.discount">
        <div class="flex w-1/4">
          Descuento aplicado:
        </div>
        <div class="flex w-3/4">
          {{ data.discount.toFixed(2) }}
        </div>
      </div>
      <div class="flex w-full my-4 text-lg">
        <div class="flex w-1/4">
          Total pagado:
        </div>
        <div class="flex w-3/4">
          <b>{{ data.orderTotal.toFixed(2) }}</b>
        </div>
      </div>
      <div class="flex w-full">
        <div class="flex w-1/4">
          Forma de pago:
        </div>
        <div class="flex w-3/4">
          {{ paymentMethod }}
        </div>
      </div>
      <div class="flex w-full">
        <div class="flex w-1/4">
          NIT para factura:
        </div>
        <div class="flex w-3/4" v-if="data.finalConsumer">
          Consumidor Final
        </div>
        <div class="flex w-3/4" v-else>
          {{ data.invoiceData.vat }} - {{ data.invoiceData.name }}
        </div>
      </div>
    </vx-card>
    <vx-card title="Productos" class="mb-2">
      <div class="flex w-full text-black border-solid border-0 border-b">
        <div class="flex w-5/12">
          Producto
        </div>
        <div class="flex w-1/12 justify-end">
          Cantidad
        </div>
        <div class="flex w-2/12 justify-end">
          Precio
        </div>
        <div class="flex w-2/12 justify-end">
          Valor
        </div>
      </div>
      <div class="flex w-full" v-for="product in data.products" :key="product.code">
        <div class="flex w-5/12">
          {{ product.description }}
        </div>
        <div class="flex w-1/12 justify-end">
          {{ product.quantity.toFixed(0) }}
        </div>
        <div class="flex w-2/12 justify-end">
          {{ product.price.toFixed(2) }}
        </div>
        <div class="flex w-2/12 justify-end">
          {{ product.amount.toFixed(2) }}
        </div>
      </div>
    </vx-card>
    <div class="flex w-full my-2">
      <vs-button color="success" icon-pack="feather" icon="icon-mail" @click="send">Enviar este detalle por correo electrónico</vs-button>
    </div>
  </div>

</template>

<script>
import {db} from '@/firebaseConfig';
export default {
  name: "Order",
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    orderDate() {
      if (this.data.date) {
        const d = this.data.date.toDate();
        return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`;
      } else {
        return new Date();
      }
    },
    paymentMethod() {
      let method = 'Efectivo';
      if (this.data.paymentMethod != '3') {
        method = 'Tarjeta de crédito.  Te llamaremos para verificar tu tarjeta. Recuerda que el titular de la tarjeta debe estar presente a la hora de la entrega con su identificación. La numeración de la tarjeta debe estar resaltada.'
      }
      return method;
    }
  },
  methods: {
    send() {
      db.collection('orders')
        .where('id', '==', this.data.id)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = doc.data();
            let emailCount = 1;
            if (data.hasOwnProperty('emailCount')) {
              emailCount = data.emailCount + 1;
            }
            db.collection('orders').doc(doc.id).update({emailCount: emailCount});
          });
        })
        .catch(() => {
          self.$router.push('/').catch(() => {});
        })
    }
  }
}
</script>

<style scoped>

</style>
